import { render, staticRenderFns } from "./DarkHeader.vue?vue&type=template&id=5f1f309e&scoped=true&"
import script from "./DarkHeader.vue?vue&type=script&lang=js&"
export * from "./DarkHeader.vue?vue&type=script&lang=js&"
import style0 from "./DarkHeader.vue?vue&type=style&index=0&id=5f1f309e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f309e",
  null
  
)

export default component.exports